/**
 * Video Controls Component
 * 
 * Handles mute/unmute functionality for videos with audio
 */

export function initVideoControls() {
    const videoContainers = document.querySelectorAll('[data-video-has-audio="true"]');
    
    if (videoContainers.length === 0) {
        return;
    }
    
    videoContainers.forEach(container => {
        const video = container.querySelector('video');
        if (!video) return;
        
        // Create sound control button
        const soundButton = createSoundButton();
        container.appendChild(soundButton);
        
        // Handle sound toggle
        soundButton.addEventListener('click', () => {
            toggleVideoAudio(video, soundButton);
        });
        
        // Update button state on video events
        video.addEventListener('volumechange', () => {
            updateButtonState(video, soundButton);
        });
        
        // Set initial state
        updateButtonState(video, soundButton);
    });
}

function createSoundButton() {
    const button = document.createElement('button');
    button.className = 'video-controls__sound-button';
    button.setAttribute('aria-label', 'Toggle video sound');
    button.setAttribute('type', 'button');
    
    // Create icon container
    const icon = document.createElement('span');
    icon.className = 'video-controls__icon';
    button.appendChild(icon);
    
    return button;
}

function toggleVideoAudio(video, button) {
    if (video.muted) {
        // Unmute the video
        video.muted = false;
        
        // Handle autoplay policy - video might pause when unmuted
        if (video.paused) {
            video.play().catch(error => {
                console.warn('Video autoplay with sound blocked by browser policy:', error);
                // If autoplay with sound is blocked, mute it again
                video.muted = true;
            });
        }
    } else {
        // Mute the video
        video.muted = true;
    }
    
    updateButtonState(video, button);
}

function updateButtonState(video, button) {
    const icon = button.querySelector('.video-controls__icon');
    
    if (video.muted) {
        button.setAttribute('aria-label', 'Unmute video');
        button.classList.remove('video-controls__sound-button--unmuted');
        button.classList.add('video-controls__sound-button--muted');
        icon.innerHTML = getSoundOffIcon();
    } else {
        button.setAttribute('aria-label', 'Mute video');
        button.classList.remove('video-controls__sound-button--muted');
        button.classList.add('video-controls__sound-button--unmuted');
        icon.innerHTML = getSoundOnIcon();
    }
}

function getSoundOnIcon() {
    return `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9V15H7L12 20V4L7 9H3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.54 8.46C16.4731 9.39309 17.0001 10.6565 17.0001 11.98C17.0001 13.3035 16.4731 14.5669 15.54 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.07 4.93C20.9447 6.80528 21.9979 9.34836 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;
}

function getSoundOffIcon() {
    return `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="23" y1="9" x2="17" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="17" y1="9" x2="23" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;
}